import React from 'react';

/**
 * Modal component to confirm navigation when user has unsaved game data.
 * Styled to match the existing EditProfile confirmation modal.
 * 
 * @param {boolean} show - Whether to show the modal
 * @param {function} onContinue - Called when user chooses to continue without saving
 * @param {function} onCancel - Called when user chooses to cancel navigation
 */
const NavigationConfirmModal = ({ show, onContinue, onCancel }) => {
  if (!show) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000
      }}
      onClick={(e) => {
        // Only close if clicking the backdrop, not the modal content
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div 
        style={{
          backgroundColor: '#121220',
          borderRadius: '10px',
          padding: '30px',
          maxWidth: '300px',
          width: '75%',
          boxShadow: '0 0 30px rgba(255, 215, 0, 0.3)',
          border: '2px solid rgba(255, 215, 0, 0.5)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{
          color: 'gold',
          fontSize: '24px',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          Lose Game Content?
        </h2>

        <p style={{
          color: 'white',
          fontSize: '16px',
          lineHeight: '1.5',
          marginBottom: '25px',
          textAlign: 'center'
        }}>
          This cannot be undone.
        </p>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '15px'
        }}>
          <button
            onClick={onContinue}
            style={{
              padding: '14px 20px',
              backgroundColor: '#ff4757',
              color: 'white',
              border: '2px solid #ff4757',
              borderRadius: '5px',
              fontWeight: 'bold',
              fontSize: '16px',
              cursor: 'pointer',
              width: '48%',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#ff3742';
              e.target.style.borderColor = '#ff3742';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#ff4757';
              e.target.style.borderColor = '#ff4757';
            }}
          >
            Continue
          </button>
          
          <button
            onClick={onCancel}
            style={{
              padding: '14px 20px',
              backgroundColor: 'rgba(255, 215, 0, 0.15)',
              color: '#ffd700',
              border: '2px solid rgba(255, 215, 0, 0.6)',
              borderRadius: '5px',
              fontWeight: 'bold',
              fontSize: '16px',
              cursor: 'pointer',
              width: '48%',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 215, 0, 0.25)';
              e.target.style.borderColor = '#ffd700';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 215, 0, 0.15)';
              e.target.style.borderColor = 'rgba(255, 215, 0, 0.6)';
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavigationConfirmModal;